import React, { Component, Fragment } from "react";
import {
  Card,
  Icon,
  Tag,
  Radio,
  Slider,
  Checkbox,
  Row,
  Col,
  Tooltip,
  Collapse
} from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import { Translate } from "react-translated";

import UniversalWholeLife from "./images/new/universal.svg";
import Term from "./images/new/term.svg";
import Employer from "./images/new/employer.svg";
import Other from "./images/new/other.svg";

import IRAs from "./images/new/ira.svg";
import Annuities from "./images/new/annuities.svg";
import SavingsAccounts from "./images/new/saving-account.svg";
import CDs from "./images/new/cds.svg";
import BrokerageAccounts from "./images/new/brokerage-account.svg";
import Cryptocurrency from "./images/new/crypto.svg";
import None from "./images/new/none.svg";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout";

const RadioGroup = Radio.Group;
const Panel = Collapse.Panel;

class Step extends Component {
  state = {
    show_insurance_question: false,
    toggle: "person",
    show_insurance_question_spouse: false
  };
  componentDidMount = () => {
    const { wizard } = this.props;
    wizard.toggle = "person";
    let show_insurance_question = false;
    let show_insurance_question_spouse = false;
    if (wizard.step_insurance_question !== null) {
      if (wizard.step_insurance_question === 5 && wizard.insurance_set === "financial") {
        show_insurance_question = true;
        this.props.updateField("step_insurance_question", 5);
      } else {
        if (
          wizard.home_mortgage_protection_toggle === "" || wizard.home_mortgage_protection_toggle === "0" ||
          wizard.home_mortgage_protection_toggle === null
        ) {
          show_insurance_question = true;
          this.props.updateField("step_insurance_question", 5);
        } else {
          show_insurance_question = false;
        }
      }
    } else {
      show_insurance_question = true;
      this.props.updateField("step_insurance_question", 5);
    }

    if (wizard.step_insurance_question_spouse !== null) {
      if (wizard.step_insurance_question_spouse === 5) {
        show_insurance_question_spouse = true;
      } else {
        if (
          wizard.home_mortgage_protection_toggle_spouse === "" ||
          wizard.home_mortgage_protection_toggle_spouse === null
        ) {
          show_insurance_question_spouse = true;
          this.props.updateField("step_insurance_question_spouse", 5);
        } else {
          show_insurance_question_spouse = false;
        }
      }
    } else {
      show_insurance_question_spouse = true;
      this.props.updateField("step_insurance_question_spouse", 5);
    }

    this.setState({ show_insurance_question });
    wizard.step_insurance_question_spouse !== null &&
      this.setState({ show_insurance_question_spouse });
  };

  onInsuranceToggleHandler = (value) => {
    if (this.props.wizard.spouse_first_name)
      this.props.updateField("home_mortgage_protection_toggle_spouse", value);
    this.props.updateField("home_mortgage_protection_toggle", value);
    this.props.updateField("life_insurance_toggle_3", value);
    this.props.updateField("insurance_set", "financial");
  };

  render() {
    let {
      show_insurance_question,
      show_insurance_question_spouse
    } = this.state;
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    // for (let i = 1; i < 21; i++) {
    //   v2 = 1000000 + 100000 * i;
    //   v1 = v2 - 100000 + 1;
    //   rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    // }
    // rangeValues.push("$3,000,001-$4,000,000");
    // rangeValues.push("$4,000,001-$5,000,000");

    let step = 500000;
      for (let i = 1; i <= 18; i++) {
        v2 = 1000000 + step * i;
        v1 = v2 - step + 1;
        rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
      }

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }

    let asset_total_value = 0;
    let asset_total_value_spouse = 0;
    if (wizard.asset_total_value !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.asset_total_value) {
          asset_total_value = parseInt(x, 10);
        }
      }
    }

    if (wizard.asset_total_value_spouse != "") {
      for (let x in marks) {
        if (marks[x].val === wizard.asset_total_value_spouse) {
          asset_total_value_spouse = parseInt(x, 10);
        }
      }
    }

    let home_mortgage_protection_benefit = 0;
    if (wizard.home_mortgage_protection_benefit !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.home_mortgage_protection_benefit) {
          home_mortgage_protection_benefit = parseInt(x, 10);
        }
      }
    }

    let home_mortgage_protection_benefit_spouse = 0;
    if (wizard.home_mortgage_protection_benefit_spouse !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.home_mortgage_protection_benefit_spouse) {
          home_mortgage_protection_benefit_spouse = parseInt(x, 10);
        }
      }
    }

    let home_mortgage_protection_policy = [];
    if (wizard.home_mortgage_protection_policy !== "") {
      home_mortgage_protection_policy = JSON.parse(
        wizard.home_mortgage_protection_policy
      );
    }

    let home_mortgage_protection_policy_spouse = [];
    if (wizard.home_mortgage_protection_policy_spouse !== "") {
      home_mortgage_protection_policy_spouse = JSON.parse(
        wizard.home_mortgage_protection_policy_spouse
      );
    }

    let asset_accounts = [];
    if (wizard.asset_accounts !== "") {
      asset_accounts = JSON.parse(wizard.asset_accounts);
      if (!asset_accounts) {
        asset_accounts = [];
      }
    }

    let asset_accounts_spouse = [];
    if (wizard.asset_accounts_spouse !== "") {
      asset_accounts_spouse = JSON.parse(wizard.asset_accounts_spouse);
      if (!asset_accounts_spouse) {
        asset_accounts_spouse = [];
      }
    }

    const asset_accounts_items = [
      {
        name: "IRA",
        icon: IRAs,
        tip:
          "Individual Retirement Plan that is usually funded by rolling over a retirement plan from a previous employer. Traditional IRA's are taxable when funds are taken out during retirement. Roth IRA's are not taxable when funds are taken out at retirement."
      },
      {
        name: "Annuities",
        icon: Annuities,
        tip:
          "Insurance contracts that people use for guaranteed income in the future."
      },
      {
        name: "Savings Account",
        icon: SavingsAccounts,
        tip:
          "An account usually held at bank. Interest paid on funds are usually higher than a checking account."
      },
      {
        name: "CDs",
        icon: CDs,
        tip:
          "A certificate of deposit that the bank issues to customers for a specific interest rate on the funds. The customer has to keep the funds in the CD for the term issued by the bank."
      },
      {
        name: "Brokerage Accounts",
        icon: BrokerageAccounts,
        tip:
          "An account established by a customer to purchase mutual funds or stocks."
      },
      {
        name: "Cryptocurrency",
        icon: Cryptocurrency,
        tip: "Cryptocurrency"
      },
      {
        name: "None",
        icon: None,
        tip: ""
      }
    ];

    const home_mortgage_policy_type = [
      {
        name: "Universal/Whole-Life",
        icon: UniversalWholeLife,
        tip:
          "A life insurance policy that provides a death benefit that has the ability to be in-force for insured's lifetime. Usually has a policy cash value."
      },
      {
        name: "Term",
        icon: Term,
        tip:
          "A life insurance policy that provides a death benefit for a specific period of time. Usually 10,15, and 20 years."
      },
      {
        name: "Employer",
        icon: Employer,
        tip:
          "A life insurance policy that's provided by the employer to purchase with no medical requirements. Usually not enough to cover the insureds life insurance needs."
      },
      {
        name: "Other",
        icon: Other,
        tip:
          "Customer doesn't know what type of policy they have but knows they have a life policy."
      }
    ];

    // Direct container reference to override App.js configuration
    const getCustomContainer = () => document.body;

    return (
      <Fragment>
        <div className="stepBody">
          <Card
            className="insidecard stepcard" >
            <div>
              <h5 className="headingText">“Do you or anyone in the household own any of the following type of accounts ?”</h5>
              <Checkbox.Group
                className=""
                value={asset_accounts}
                style={{ width: "100%" }}
                onChange={(checkedList) => {
                  if (
                    checkedList.length > 0 &&
                    checkedList[checkedList.length - 1] === "None"
                  ) {
                    updateField("asset_accounts", JSON.stringify(["None"]));
                    updateField("asset_total_value", ""); // new add
                  } else {
                    if (checkedList.length === 0) {
                      updateField("asset_total_value", ""); // new add
                    } else if (checkedList.indexOf("None") >= 0) {
                      checkedList.splice(checkedList.indexOf("None"), 1);
                    }
                    updateField("asset_accounts", JSON.stringify(checkedList));
                  }
                  if (!this.props.isExternalBFile) {
                    updateRadioBtnToggle();
                  }
                }}

              >
                <h5 className="titleText2 headingText">Please Select Checklist : </h5>
                <Row gutter={[32, 32]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {asset_accounts_items.map((item, i) => {
                    return (
                      <Col key={i}
                        xs={24}
                        sm={12}
                        md={8}
                        lg={6} className="checkbox_layout">
                        {item.tip !== "" ? (
                          <Tooltip placement="bottom" title={item.tip} getPopupContainer={getCustomContainer}
                          >
                            <Checkbox value={item.name} style={{ width: "100%" }}>
                              <div className="checkbox_items"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <div className="icon"
                                  style={{ flexShrink: 0 }}
                                >
                                  <img src={item.icon} alt={item.name}
                                    style={{
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                                <div className="title" style={{ flexGrow: 1 }}>
                                  <Translate text={item.name} />
                                </div>
                              </div>
                            </Checkbox>
                          </Tooltip>
                        ) : (
                          <Checkbox value={item.name} style={{ width: "100%" }}>
                            <div className="checkbox_items">
                              <div className="icon">
                                <img src={item.icon} alt={item.name}
                                  style={{
                                    objectFit: "contain",
                                  }} />
                              </div>
                              <div className="title">
                                <Translate text={item.name} style={{ flexGrow: 1 }} />
                              </div>
                            </div>
                          </Checkbox>
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </Checkbox.Group>
            </div>
            {asset_accounts.length > 0 && asset_accounts.indexOf("None") < 0 ? (
              <div style={{ marginTop: 20 }}>
                <h5 className="headingText">
                  “What is the total approximate value of these accounts ?” <span className='asteriskIcon'>*</span>
                </h5>
                <div
                  style={{
                    width: "100%",
                    maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                    margin: "0 auto",
                    padding: "10px",
                  }}
                >
                  <SliderLayout
                    marks={marks}
                    value={asset_total_value}
                    name="asset_total_value"
                    updateField={updateField}
                    updateRadioBtnToggle={updateRadioBtnToggle}
                  />
                </div>
                <div className="sliderValue center-align silder-align"

                >
                  {wizard.asset_total_value || "$0"}
                </div>
              </div>
            ) : null}
            {wizard.spouse_first_name && (
              <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                  <div>
                    <h4 className="titleTextUnderline headingText">
                      <Translate text={`Spouse's/Partner's Accounts`} />
                    </h4>
                    <div style={{ marginTop: 20 }}>
                      <h5 className="headingText">"Do you or anyone in the household own any of the following type of accounts?"</h5>
                      <Checkbox.Group
                        className=""
                        value={asset_accounts_spouse}
                        style={{ width: "100%" }}
                        onChange={(checkedList) => {
                          if (
                            checkedList.length > 0 &&
                            checkedList[checkedList.length - 1] === "None"
                          ) {
                            updateField(
                              "asset_accounts_spouse",
                              JSON.stringify(["None"])
                            );
                            updateField("asset_total_value_spouse", ""); // new add
                          } else {
                            if (checkedList.length === 0) {
                              updateField("asset_total_value_spouse", ""); // new add
                            } else if (checkedList.indexOf("None") >= 0) {
                              checkedList.splice(checkedList.indexOf("None"), 1);
                            }
                            updateField(
                              "asset_accounts_spouse",
                              JSON.stringify(checkedList)
                            );
                          }
                          if (!this.props.isExternalBFile) {
                            updateRadioBtnToggle();
                          }
                        }}


                      >

                        <h5 className="titleText2 headingText">Please Select Checklist : </h5>
                        <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                          {asset_accounts_items.map((item, i) => {
                            return (
                              <Col key={i}
                                xs={24}
                                sm={12}
                                md={8}
                                lg={6} className="checkbox_layout">
                                {item.tip !== "" ? (
                                  <Tooltip placement="bottom" title={item.tip} getPopupContainer={getCustomContainer}>
                                    <Checkbox value={item.name} style={{ width: "100%" }}>
                                      <div className="checkbox_items step5"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <div className="icon"
                                          style={{ flexShrink: 0 }}
                                        >
                                          <img src={item.icon} alt={item.name}
                                            style={{
                                              objectFit: "contain",
                                            }}
                                          />
                                        </div>
                                        <div className="title" style={{ flexGrow: 1 }}>
                                          <Translate text={item.name} />
                                        </div>
                                      </div>
                                    </Checkbox>
                                  </Tooltip>
                                ) : (
                                  <Checkbox value={item.name} style={{ width: "100%" }}>
                                    <div className="checkbox_items step5">
                                      <div className="icon">
                                        <img src={item.icon} alt={item.name}
                                          style={{
                                            objectFit: "contain",
                                          }}
                                        />
                                      </div>
                                      <div className="title" style={{ flexGrow: 1 }}>
                                        <Translate text={item.name} />
                                      </div>
                                    </div>
                                  </Checkbox>
                                )}
                              </Col>
                            );
                          })}
                        </Row>
                      </Checkbox.Group>
                    </div>
                    {asset_accounts_spouse.length > 0 &&
                      asset_accounts_spouse.indexOf("None") < 0 ? (
                      <div style={{ marginTop: 20 }}>
                        <h5 className="headingText">“What is the total approximate value of these accounts ?”</h5>
                        <SliderLayout
                          marks={marks}
                          value={asset_total_value_spouse}
                          name="asset_total_value_spouse"
                          updateField={updateField}
                          updateRadioBtnToggle={updateRadioBtnToggle}
                        />
                        <div className="sliderValue center-align silder-align">
                          {wizard.asset_total_value_spouse || "$0"}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Panel>
              </Collapse>
            )}
            {show_insurance_question ? (
              <div style={{ marginTop: 20 }} >
                <h4 className="titleTextUnderline headingText">Life Insurance</h4>
                <div style={{ marginTop: 20 }}>
                  <h5 className="headingText">“Does anyone in the household own life insurance to pay for final expenses or debt repayment and, if so, what type of policy is it and what is the total death benefit? ” <span className='asteriskIcon'>*</span></h5>
                  <RadioGroup
                    className="radiogroup"
                    value={wizard.life_insurance_toggle_3}
                    onChange={(e) => {
                      this.onInsuranceToggleHandler(e.target.value);
                      if (!this.props.isExternalBFile) {
                        updateRadioBtnToggle();
                      }
                    }
                    }
                  >
                    <Radio value="1">
                      <Translate text={`Yes`} />
                    </Radio>
                    <Radio value="0">
                      <Translate text={`No`} />
                    </Radio>
                  </RadioGroup>
                </div>


                {wizard.home_mortgage_protection_toggle === "1" ? (
                  <div style={{ marginTop: 20 }}>
                    <h5 className="titleText2 headingText">Please Select Checklist : <span className='asteriskIcon'>*</span>
                    </h5>
                    <Checkbox.Group
                      className=""
                      value={home_mortgage_protection_policy}
                      style={{ width: "100%" }}
                      onChange={(checkedList) => {
                        updateField(
                          "home_mortgage_protection_policy",
                          JSON.stringify(checkedList)
                        );
                        if (!this.props.isExternalBFile) {
                          updateRadioBtnToggle();
                        }
                      }
                      }

                    >
                      <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {home_mortgage_policy_type.map((item, i) => {
                          return (
                            <Col key={i}
                              xs={24}
                              sm={12}
                              md={8}
                              lg={6} className="checkbox_layout">
                              <Tooltip placement="bottom" title={item.tip} getPopupContainer={getCustomContainer}>
                                <Checkbox value={item.name} style={{ width: "100%" }}>
                                  <div className="checkbox_items step6"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <div className="icon"
                                      style={{ flexShrink: 0 }}
                                    >
                                      <img src={item.icon} alt={item.name}
                                        style={{
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                    <div className="title" style={{ flexGrow: 1 }}>
                                      <Translate text={item.name} />
                                    </div>
                                  </div>
                                </Checkbox>
                              </Tooltip>
                            </Col>
                          );
                        })}
                      </Row>
                    </Checkbox.Group>

                    {wizard.home_mortgage_protection_policy && wizard.home_mortgage_protection_policy.length > 2 && <div style={{ marginTop: 20 }}>
                      <h5 className="headingText">“What is the total approximate benefit value ?” <span className='asteriskIcon'>*</span></h5>
                      <SliderLayout
                        marks={marks}
                        value={home_mortgage_protection_benefit}
                        name="home_mortgage_protection_benefit"
                        updateField={updateField}
                        updateRadioBtnToggle={updateRadioBtnToggle}
                      />
                      <div className="sliderValue center-align silder-align">
                        {wizard.home_mortgage_protection_benefit || "$0"}
                      </div>
                    </div>}

                    {wizard.spouse_first_name && (
                      <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                        <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                          <div>
                            <h4 className="titleTextUnderline headingText">
                              <Translate text={`Spouse's/Partner's Policy`} />
                            </h4>
                            <h5 className="titleText2 headingText">Please Select Checklist : </h5>
                            <Checkbox.Group
                              className=""
                              value={home_mortgage_protection_policy_spouse}
                              style={{ width: "100%" }}
                              onChange={(checkedList) => {
                                updateField(
                                  "home_mortgage_protection_policy_spouse",
                                  JSON.stringify(checkedList)
                                );
                                if (!this.props.isExternalBFile) {
                                  updateRadioBtnToggle();
                                }
                              }
                              }

                            >
                              <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: "space-evenly" }}>
                                {home_mortgage_policy_type.map((item, i) => {
                                  return (
                                    <Col key={i}
                                      xs={24}
                                      sm={12}
                                      md={8}
                                      lg={6} className="checkbox_layout">
                                      <Tooltip
                                        placement="bottom"
                                        title={item.tip}
                                        getPopupContainer={getCustomContainer}
                                      >
                                        <Checkbox value={item.name} style={{ width: "100%" }}>
                                          <div className="checkbox_items step6"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <div className="icon"
                                              style={{ flexShrink: 0 }}
                                            >
                                              <img
                                                style={{
                                                  objectFit: "contain",
                                                }}
                                                src={item.icon}
                                                alt={item.name}
                                              />
                                            </div>
                                            <div className="title" style={{ flexGrow: 1 }}>
                                              <Translate text={item.name} />
                                            </div>
                                          </div>
                                        </Checkbox>
                                      </Tooltip>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Checkbox.Group>

                            {wizard.home_mortgage_protection_policy_spouse && wizard.home_mortgage_protection_policy_spouse.length > 2 && <div style={{ marginTop: 20 }}>
                              <h5 className="headingText">“What is the total approximate benefit value ?”</h5>
                              <div
                                style={{
                                  width: "100%",
                                  maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                                  margin: "0 auto",
                                  padding: "10px",
                                }}
                              >
                                <SliderLayout
                                  marks={marks}
                                  value={home_mortgage_protection_benefit_spouse}
                                  name="home_mortgage_protection_benefit_spouse"
                                  updateField={updateField}
                                  updateRadioBtnToggle={updateRadioBtnToggle}
                                />
                              </div>
                              <div className="sliderValue center-align silder-align"
                              >
                                {wizard.home_mortgage_protection_benefit_spouse ||
                                  "$0"}
                              </div>
                            </div>}
                          </div>
                        </Panel>
                      </Collapse>

                    )}
                  </div>
                ) : null}
              </div>
            ) : null}


            <Row style={{ display: 'flex', justifyContent: 'center' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">"If you do not have sufficient liability coverage to protect your assets, your assets may be subject to being liened, garnished or attached in a lawsuit."</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div >
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment >
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step5_updated.js